module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-en-1.621d16ea.png";